import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  CardActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";
import { FormattedMessage } from "react-intl";
import { useMutation } from "@apollo/client";

import GenericAdminPageSkeleton from "../../../Skeleton/GenericAdminPageSkeleton";
import themeCollection from "../../../../theme/themeCollection";
import UPDATE_COMPANY_DEFAULT_THEME from "../../../../graphql/mutations/CompanyAdminContext/CompanySettings/updateCompanyDefaultTheme";

const CompanyColorTheme = ({ classes, companyId, initialTheme }) => {

  const [draftTheme, setDraftTheme] = useState(null);

  const selectedTheme = draftTheme ?? initialTheme ?? "";

  const handleChange = (event) => {
    setDraftTheme(event.target.value);
  };
   
  const [updateCompanyTheme, { loading }] = useMutation(
    UPDATE_COMPANY_DEFAULT_THEME
  );

  const handleSave = async () => {
    if (!selectedTheme) return;

    try {

      await updateCompanyTheme({
        variables: {
          companyId,
          defaultTheme: selectedTheme,
        },
      });      

      console.log("Theme updated");
    } catch (error) {
      console.error("Failed to update company theme:", error);
    }
  };

  if (!companyId || !initialTheme) {
    return <GenericAdminPageSkeleton />;
  }

  return (
    <>
      <Box className={classes.headMarginBottom}>
        <Typography className={classes.headTitle}>
          <FormattedMessage id="admin.companySettings.colorTheme.Title" />
        </Typography>
      </Box>

      <Card>
        <CardContent className={classes.selectCard}>
          <Box sx={{ minWidth: 120, paddingTop: "25px" }}>
            <FormControl fullWidth>
              <InputLabel id="theme-select-label">
                <FormattedMessage id="admin.companySettings.colorTheme.selectColorTheme" />
              </InputLabel>

              <Select
                labelId="theme-select-label"
                value={selectedTheme}
                label="Välj färgtema"
                onChange={handleChange}
              >
                {themeCollection.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </CardContent>

        <CardContent sx={{ paddingBottom: "12px" }}>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ fontSize: 20 }}
          >
            <FormattedMessage id="admin.companySettings.colorTheme.Title" />
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: 16 }}
          >
            <FormattedMessage id="admin.companySettings.colorTheme.subTitle" />            
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: "bold" }}
          >
            <FormattedMessage id="admin.companySettings.colorTheme.warning" />
          </Typography>
        </CardContent>

        <Divider />

        <CardActions
          sx={{ width: "100%", padding: "16px" }}
          className={classes.actionButtons}
        >
          <Button
            size="small"
            variant="outlined"
            className={classes.btnDesign}
            startIcon={<SaveIcon />}
            onClick={handleSave}
            disabled={!selectedTheme || loading}
          >
            {loading ? "Sparar..." : "Spara"}
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default CompanyColorTheme;